$(document).ready(function(){
	
	$(".sticky").sticky({ topSpacing: 20 });
	
	$('#printInfo').on('click',function(){
		window.print();
	});
	$('.tourPhoto').bxSlider({
		mode: 'fade',
		pagerCustom: '#bx-pager'
	});
	$('#showThumbs').click(function() {
		$("#bx-pager").toggleClass('opened');
	});
	$( "#accordion" ).accordion();

	$('.btn-share').click(function() {
		$(".share-popover").toggleClass('opened');
	});
	$('body').click(function(event) {
		if (!$(event.target).closest('.popover-wrap').length) {
			$('.share-popover').removeClass('opened');
		};
	});
	$('#selectPrice').on('change', function() {
		var nbsp = String.fromCharCode(160);
		textArr = $("#selectPrice option:selected").text().split(nbsp + nbsp + nbsp);
		$('#reservationText').html(textArr[1]);
		$("input[type='hidden'][name='tourPriceKey']").val($(this).val());
	})

    $("input[type='hidden'][name='tourPriceKey']").val($('#selectPrice').val());

    // Daily tour pax selection
    $('#paxADT').val("1");
    $('#paxCHD').val("0");
    $('#paxINF').val("0");

    $( ".spinnerTravelerADT" ).spinner({
        min: 1,
        max: 9
    });
    $( ".spinnerTravelerCHD" ).spinner({
        min: 0,
        max: 2
    });
    $( ".spinnerTravelerINF" ).spinner({
        min: 0,
        max: 2
    });

    $(".spinnerTravelerADT, .spinnerTravelerCHD, .spinnerTravelerINF").change(function(){
        var paxADT = $( "[name=paxADT]" ).spinner( "value" );
        var paxCHD = $( "[name=paxCHD]" ).spinner( "value" );
        var paxINF = $( "[name=paxINF]" ).spinner( "value" );
        var totalPax = paxADT + paxCHD + paxINF;
        $(".travelerSelectPax").html(totalPax);
        var locale = $.cookie('siteLocale');
        if(locale == "en"){
            if(totalPax > 1){
                $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.travelers'));
            }else{
                $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
            }
        }else if(locale == "ru" || locale == "uk"){
            var partLast2 = totalPax % 100;
            var partLast1 = totalPax % 10;
            if(partLast1 == 0 || (partLast1 >= 5 && partLast1 <= 9) || (partLast2 >= 11 && partLast2 <= 14)){
                $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru3'));
            }else if(partLast1 == 1){
                $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru1'));
            }else if(partLast1 >= 2 && partLast1 <= 4){
                $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru2'));
            }
        }else{
            $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
        }
    });

    $(".spinnerTravelerADT, .spinnerTravelerCHD, .spinnerTravelerINF").on("spinstop",function(){
        $(this).change();
    });$(".btn-detailed").click(function() {
        $('.detailed-search').toggle("fade","fast");
        $(this).toggleClass("btn-close");
        return false;
    });

    $(".travelerSelect").click(function() {
        $('.travelerList').toggle("fade","fast");
        return false;
    });

    // Package tour pax selection
    $( ".roomSelect" ).spinner({});
    $( ".adultCount" ).spinner({});
    $( ".childCount" ).spinner({});
    $( ".childAge" ).spinner({});

    $(document).on("spinstop",".roomSelect, .adultCount, .childCount, .childAge",function(){
        $(this).change();
    });

    $(document).on("click",".selectPerson",function() {
        $(".person-popover").toggle("fade","fast");

        $( ".roomSelect" ).spinner({});
        $( ".adultCount" ).spinner({});
        $( ".childCount" ).spinner({});
        $( ".childAge" ).spinner({});
        return false;
    });

    bindRoomSelector();

    //Common for daily and package tour pax selection
    $('body').click(function(event) {
        if (!$(event.target).closest('.person-popover').length) {
            $('.person-popover').hide();
        };
        if (!$(event.target).closest('.travelerList').length) {
            $('.travelerList').hide();
        };
    });

    $(".pop-close-btn,.pop-btn-ok,.popover-close").click(function() {
        $('.classList, .travelerList').hide();
        $('.person-popover').hide();
        return false;
    });

});

function directIntoReservationPage(tourId){
	$("input[type='hidden'][name='tourId']").val(tourId);
	var $form = $('[name="priceDetailToursForm"]');
	$form.submit();
}

function bindRoomSelector(context) {

    if (context == undefined)
        context = document;

    $(".roomSelect", context).on('change', function(event) {

        var roomCount = $(this).val();
        $(".roomSelect").val(roomCount);
        $(".travelerSelectRoom").html(roomCount);
        for ( var i = 1; i < 5; i++) {
            if (i <= roomCount) {
                $(".room" + i).show();
            } else {
                $(".room" + i).hide();
            }
        }
//		$(this).closest("form").find(".travelerSelectRoom").html(roomCount);
        setTotalGuest($(this).closest("form"));

        var locale = $.cookie('siteLocale');
        if(locale == "en" && roomCount > 1){
            $(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.rooms'));
        }else{
            $(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.room'));
        }

    }).change();

    $(".childCount", context).on('change', function (event) {

        var childCount =  parseInt(this.value);
        var index = this.name.split('_')[1];
        $("[name="+this.name+"]").val(childCount);

        for ( var i = 1; i < 4; i++) {
            if (i <= childCount) {
                $(".childAge" + index + i).show();
            } else {
                $(".childAge" + index + i).hide();
            }
        }

        setTotalGuest($(this).closest("form"));

    }).change();

    $(".adultCount", context).on('change', function (event) {
        $("[name="+this.name+"]").val(parseInt(this.value));
        setTotalGuest($(this).closest("form"));
    }).change();

    $(".childAge", context).on('change', function (event) {
        $("[name="+this.name+"]").val(parseInt(this.value));
    }).change();

}

function setTotalGuest(form) {
    var roomCount = parseInt(form.find("#glRoomCount").val());
    var totalAdultCount = 0;
    var totalChildCount = 0;
    for ( var i = 1; i <= roomCount; i++) {
        totalAdultCount = totalAdultCount + parseInt(form.find("[name=adultCount_" + i + "]").val());
        totalChildCount = totalChildCount + parseInt(form.find("[name=childCount_" + i + "]").val());
    }
    var totalGuest = totalAdultCount + totalChildCount;
    $(".travelerSelectGuest").html(totalGuest);
    var locale = $.cookie('siteLocale');
    if(locale == "en" && totalGuest > 1){
        $(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guests'));
    }else{
        $(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guest'));
    }
}

function openShareWindows(url, target){
    switch(target) {
        case 'facebook':
            window.open('https://www.facebook.com/sharer/sharer.php?u='+url+'','_blank','width=600,height=600,scrollbars=no,resizable=no');
            break;
        case 'twitter':
            window.open('https://twitter.com/home?status='+url+'','_blank','width=600,height=600,scrollbars=no,resizable=no');
            break;
        case 'whatsapp':
            window.open('https://api.whatsapp.com/send?text='+url+'','_blank','width=600,height=600,scrollbars=no,resizable=no');
            break;
        default:
            break;
    }
}
